import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'
import { filterDOMProps } from '@react-aria/utils'

export const Blog = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32, ...rest }, forwardedRef) => {
    const domProps = filterDOMProps(rest, { labelable: true, propNames: new Set(['role']) })
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...domProps}
      >
        <rect
          x="7.43718"
          y="10.5531"
          width="17.1256"
          height="8.52493"
          rx="1.3"
          fill="#88F200"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <rect
          x="4.45"
          y="19.1031"
          width="23.1"
          height="8.6"
          rx="1.3"
          fill="#05D200"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <rect
          x="10.2"
          y="4.79058"
          width="11.6"
          height="5.69375"
          rx="1.3"
          fill="#FCFF66"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.7339 13.9938C22.1205 13.9938 22.4339 13.6803 22.4339 13.2938C22.4339 12.9072 22.1205 12.5938 21.7339 12.5938L10.266 12.5938C9.87944 12.5938 9.56604 12.9072 9.56604 13.2938C9.56604 13.6803 9.87944 13.9938 10.266 13.9938H21.7339ZM14.4853 16.9938C14.8719 16.9938 15.1853 16.6803 15.1853 16.2938C15.1853 15.9072 14.8719 15.5938 14.4853 15.5938L10.266 15.5938C9.87944 15.5938 9.56604 15.9072 9.56604 16.2938C9.56604 16.6803 9.87944 16.9938 10.266 16.9938H14.4853Z"
          fill="#2B2F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.5628 22.6031C24.9494 22.6031 25.2628 22.2897 25.2628 21.9031C25.2628 21.5165 24.9494 21.2031 24.5628 21.2031L7.43718 21.2031C7.05058 21.2031 6.73718 21.5165 6.73718 21.9031C6.73718 22.2897 7.05058 22.6031 7.43718 22.6031L24.5628 22.6031ZM22.2793 25.6032C22.6659 25.6033 22.9793 25.2899 22.9794 24.9033C22.9794 24.5167 22.666 24.2033 22.2794 24.2032L7.43719 24.2031C7.05059 24.2031 6.73719 24.5165 6.73718 24.9031C6.73718 25.2897 7.05058 25.6031 7.43717 25.6031L22.2793 25.6032Z"
          fill="#2B2F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9292 7.6375C19.9292 8.0241 19.6158 8.3375 19.2292 8.3375H12.7709C12.3843 8.3375 12.0709 8.0241 12.0709 7.6375C12.0709 7.2509 12.3843 6.9375 12.7709 6.9375H19.2292C19.6158 6.9375 19.9292 7.2509 19.9292 7.6375Z"
          fill="#2B2F38"
        />
      </svg>
    )
  },
)

export default Blog
